<script setup lang="ts">
  import { DocumentType } from '$types';
  import type { PropType } from 'vue';

  defineOptions({
    layout: ['StoreLayout', 'AccountLayout'],
    inheritAttrs: false,
  });

  type OrderDocument = {
    id: number;
    type: DocumentType;
    reference_number: string;
    download: string;
  }

  defineProps({
    order: { type: Object, required: true },
    repayment: { type: String, required: false },
    documents: { type: Array as PropType<OrderDocument[]>, required: false, default: [] },
    packages: { type: Array, required: false, default: [] },
  });
</script>
<template>
  <AccountMobileNavigation :href="route('web.account.order.index')">
    {{ $t('Zamówienie Nr') }} {{ order.id }}
  </AccountMobileNavigation>
  <OrderDetailsView v-bind="$props" />
</template>
